module.exports = __webpack_public_path__ + "img/order-step5-b.f3866478.png";